import { DataType } from '../../data-type';
import { ITextItem } from './text-item';

export interface IToggleItem {
    property: string,
    type: DataType,
    value: number,
    label: string | React.ReactNode,
    values: any[],
    disabled?: boolean,
    additional?: ITextItem[]
}